import type { TokenValidatorRepository } from '@/shared/contracts/tokenValidator.repository';
import { jwtDecode } from 'jwt-decode';

/**
 * Servicio de validación de tokens JWT con decodificación y verificación de expiración
 * Cumple con SRP: responsabilidad única de validar y decodificar tokens JWT
 */
class JwtTokenValidatorService implements TokenValidatorRepository {
  /**
   * Valida si un token JWT es válido y no ha expirado
   * @param token - Token JWT a validar
   */
  validateToken(token: string | null): boolean {
    try {
      if (!token) return false;
      const decoded: { exp: number } = jwtDecode(token);
      return decoded.exp * 1000 > Date.now();
    } catch {
      return false;
    }
  }

  /**
   * Extrae y decodifica el payload de un token JWT
   * @param token - Token JWT a decodificar
   */
  extractTokenPayload(token: string): Record<string, any> | null {
    try {
      return jwtDecode(token);
    } catch {
      return null;
    }
  }

  /**
   * Verifica si un token JWT ha expirado
   * @param token - Token JWT a verificar
   */
  isTokenExpired(token: string): boolean {
    try {
      const decoded: { exp: number } = jwtDecode(token);
      return decoded.exp * 1000 <= Date.now();
    } catch {
      return true;
    }
  }
}

export const jwtTokenValidatorService = new JwtTokenValidatorService();
